import React from "react";
import { Cloud, Code2, Cpu, ShieldCheck, Smartphone } from "lucide-react";

import { Hero, FeaturesGrid, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";
import { services } from "../content/services";

function SoftwareDevelopment() {
  const service = services.find((s) => s.id === "software-dev");

  return (
    <div>
      <Seo title="Software Development" description={service.description} />
      <Hero
        eyebrow="Service"
        title="Software Development"
        subtitle={service.description}
        primaryCta={{ label: "Start a project", to: "/Contact" }}
        secondaryCta={{ label: "Explore products", to: "/EasyBooks_Accounting" }}
        imageSrc={service.heroSrc}
        imageAlt="Software development"
        highlights={service.highlights}
      />

      <FeaturesGrid
        eyebrow="Capabilities"
        title="End-to-end delivery for web, mobile, and cloud."
        subtitle="We help you ship fast while maintaining quality, security, and long-term maintainability."
        columns={3}
        features={[
          {
            title: "Web application development",
            description: "Enterprise-grade web solutions that power mission-critical workflows.",
            icon: Code2,
          },
          {
            title: "Mobile app development",
            description: "Stellar mobile experiences at scale—apps your users will love.",
            icon: Smartphone,
          },
          {
            title: "Cloud hosting services",
            description: "Secure cloud storage and infrastructure to support growth.",
            icon: Cloud,
          },
          {
            title: "Security-first engineering",
            description: "Carefully crafted components and secure delivery practices.",
            icon: ShieldCheck,
          },
          {
            title: "Performance & reliability",
            description: "Systems designed for high concurrency and dependable uptime.",
            icon: Cpu,
          },
        ]}
      />

      <CTASection
        title="Have an idea you want to ship?"
        subtitle="Share your goals and timelines we’ll propose an approach and next steps."
        primaryCta={{ label: "Contact us", to: "/Contact" }}
        secondaryCta={{ label: "See BPR services", to: "/BRP" }}
      />
    </div>
  );
}

export default SoftwareDevelopment;